module.exports = __webpack_public_path__ + "static/other/gameSpacePets.943d19aa.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameSpacePets.json
// module id = 2508
// module chunks = 0